// @flow
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import type {
  StatelessFunctionalComponent,
  Node,
} from 'react';
import type {
  Dispatch,
} from 'chronos-types';

import * as selectors from 'chronos-selectors';
import * as actions from 'chronos-actions';

import {
  AutoDismissFlag as Flag,
  FlagGroup,
} from '@atlaskit/flag';

import EditorWarningIcon from '@atlaskit/icon/glyph/editor/warning';
import NotificationAllIcon from '@atlaskit/icon/glyph/notification-all';
import FlagSpinner from './FlagSpinner';

import FlagHoc from './FlagHoc';


type Props = {
  flags: Array<any>,
  dispatch: Dispatch,
}

function getIcon(iconName) {
  return iconName === 'errorIcon'
    ? <EditorWarningIcon label="huy" size="medium" primaryColor="red" />
    : <NotificationAllIcon label="pizda" size="medium" primaryColor="blue" />;
}

const mapState = state => ({
  flags: selectors.getUiState('flags')(state),
});

const FlagsContainer: StatelessFunctionalComponent<Props> = (): Node => {
  const { flags } = useSelector(mapState);
  const dispatch: Dispatch = useDispatch();

  return (
    <FlagGroup
      onDismissed={(id) => {
        dispatch(actions.deleteFlag(id));
      }}
    >
      {flags.map(flag => (
        <FlagHoc
          key={flag.id}
          resourceType={flag.resourceType}
          request={flag.request}
          render={pending => (
            <Flag
              title={
                pending
                  ? <FlagSpinner spinnerTitle={flag.spinnerTitle} />
                  : flag.title
              }
              actions={flag.actions}
              appearance={flag.appearance}
              description={flag.description}
              icon={getIcon(flag.icon)}
            />
          )}
        />
      ))}
    </FlagGroup>
  );
};

export default FlagsContainer;
